var _g, _path, _path2, _path3, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_145_1867)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(90 27 0)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5238 6.34787C12.4112 6.34787 12.3281 6.43329 12.3281 6.53814V7.71112C12.3281 7.73631 12.3331 7.76124 12.3428 7.78445C12.3525 7.80775 12.3668 7.82879 12.3847 7.84649C12.4025 7.86419 12.4238 7.87818 12.4471 7.88758C12.4705 7.89697 12.4956 7.90166 12.5207 7.90139H18.3496C18.4002 7.90139 18.4489 7.88143 18.485 7.84576C18.5211 7.81018 18.5416 7.76178 18.5422 7.71112V6.53814C18.5422 6.43176 18.4544 6.34787 18.3465 6.34787H17.7655L16.9886 5.57104H13.8815L13.1047 6.34787L12.5238 6.34787Z",
    fill: "#C7C7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8746 11.7852L20.2825 12.5672L19.6908 11.7852C19.5964 11.7869 19.5051 11.7511 19.4369 11.6855C19.3688 11.6201 19.3293 11.5302 19.3273 11.4357L19.3297 10.5813C19.3276 10.4867 19.2882 10.3969 19.2201 10.3314C19.152 10.2658 19.0607 10.23 18.9661 10.2317C18.877 10.2313 18.7907 10.263 18.723 10.321L15.4948 12.8231C15.4774 12.8384 15.4634 12.8571 15.4537 12.8781C15.4438 12.899 15.4384 12.9218 15.4377 12.9449C15.437 12.968 15.441 12.9911 15.4494 13.0126C15.4579 13.0341 15.4707 13.0536 15.487 13.0701C15.4885 13.0716 16.5667 13.909 18.7231 15.5791C18.7955 15.6413 18.8892 15.6734 18.9846 15.6686C19.0799 15.6638 19.1699 15.6226 19.2358 15.5536C19.2955 15.4903 19.3288 15.4066 19.329 15.3197L19.3274 14.4753C19.3294 14.381 19.3688 14.2913 19.4367 14.2258C19.5047 14.1603 19.5958 14.1244 19.6902 14.1258L20.2825 12.5672L20.8746 11.7852L20.8747 16.4522C20.8747 17.3066 20.178 17.9995 19.3165 17.9995H11.5582C11.1465 18.0008 10.751 17.8385 10.4589 17.5484C10.1667 17.2582 10.0016 16.8639 10 16.4522V7.89522C10 7.04236 10.6943 6.35045 11.5535 6.34791V8.29373C11.5535 8.51119 11.7306 8.67826 11.9497 8.67826H18.9252C19.1443 8.67826 19.3214 8.50577 19.3214 8.29373V6.34791H19.3167C19.7285 6.34664 20.1239 6.50892 20.4161 6.79908C20.7082 7.08924 20.8733 7.4835 20.8749 7.89522L20.8746 11.7852ZM12.7192 11.0085C12.6161 11.0085 12.5174 11.0494 12.4446 11.1222C12.3717 11.1951 12.3308 11.2939 12.3308 11.3968C12.3308 11.4999 12.3717 11.5987 12.4446 11.6715C12.5173 11.7443 12.6161 11.7852 12.7192 11.7852H15.0495C15.1525 11.7852 15.2513 11.7443 15.3241 11.6715C15.3969 11.5987 15.4379 11.4999 15.4379 11.3968C15.4379 11.2939 15.3969 11.1951 15.3241 11.1222C15.2513 11.0494 15.1525 11.0085 15.0495 11.0085H12.7192ZM12.7184 14.1156C12.6154 14.1156 12.5166 14.1565 12.4438 14.2294C12.371 14.3022 12.3301 14.401 12.3301 14.504C12.3301 14.607 12.371 14.7058 12.4438 14.7786C12.5166 14.8514 12.6154 14.8924 12.7184 14.8924H15.0487C15.1517 14.8924 15.2505 14.8514 15.3233 14.7786C15.3962 14.7058 15.4371 14.607 15.4371 14.504C15.4371 14.401 15.3962 14.3022 15.3233 14.2294C15.2505 14.1565 15.1517 14.1156 15.0487 14.1156H12.7184ZM12.7184 12.5621H14.272C14.3749 12.5621 14.4737 12.603 14.5466 12.6758C14.6194 12.7487 14.6603 12.8475 14.6603 12.9504C14.6603 13.0534 14.6194 13.1522 14.5466 13.225C14.4737 13.2979 14.3749 13.3388 14.272 13.3388H12.7184C12.6154 13.3388 12.5166 13.2979 12.4438 13.225C12.371 13.1522 12.3301 13.0534 12.3301 12.9504C12.3301 12.8475 12.371 12.7487 12.4438 12.6758C12.5166 12.603 12.6154 12.5621 12.7184 12.5621Z",
    fill: "#C7C7C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L11.5 10.5V17L17.5 16H20.5V12L20 9Z",
    fill: "#C7C7C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_145_1867",
    x: 9.53674e-7,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_145_1867"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_145_1867",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasteIcon);
export default __webpack_public_path__ + "static/media/paste-icon.936cbcb3e109b4ad86767b880d932f48.svg";
export { ForwardRef as ReactComponent };